<template>
  <div id="optionsViewer">
    <ol>
      <li v-for="option in selectedOptions" :key="option.key">
        <b-field
          custom-class=""
          style="flex-grow: 2;"
          horizontal
          :label="$t(option.key)"
        >
          <b-tag v-for="selectedOption in option.value" :key="selectedOption">
            {{ formatOption(selectedOption) }}
          </b-tag>
        </b-field>
      </li>
      <slot></slot>
    </ol>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'OptionsViewer',
  props: ['optionsObject'],
  methods: {
    formatValue(value) {
      if (/^([0-9]{1,15})$/.test(value)) {
        return this.toCurrency(parseInt(value))
      } else if (/^([0-9]{1,15})-*/.test(value)) {
        return (
          this.toCurrency(value.split('-')[0]) +
          ' - ' +
          this.toCurrency(value.split('-')[1])
        )
      }
      return value
    },
    toCurrency(value) {
      if (isNaN(parseInt(value))) {
        return value
      }
      value = parseInt(value)
      var formatter = new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0
      })
      return formatter.format(value)
    },
    formatOption: function(option) {
      if (/^([0-9]{17,})$/.test(option)) {
        return moment(
          option.substring(0, option.length - 3),
          'YYYYMMDDHHmmss'
        ).format('DD-MM-YYYY, h:mm:ss a')
      }
      let translatedOption = this.$t(option)
      if (translatedOption.includes('#')) {
        let splittedTranslatedOption = translatedOption.split('#')
        translatedOption = splittedTranslatedOption.join(' ')
      }
      return translatedOption
    }
  },
  computed: {
    selectedOptions: function() {
      let options = []
      const entries = Object.entries(this.optionsObject)
      entries.forEach(function(entry) {
        if (entry[1]) {
          if (typeof entry[1] === 'object') {
            if (entry[1].length > 0) {
              options.push({
                key: entry[0],
                value: entry[1]
              })
            }
          } else {
            options.push({
              key: entry[0],
              value: [entry[1]]
            })
          }
        }
      })
      return options
    }
  }
}
</script>

<style lang="scss">
#optionsViewer {
  z-index: 3;
  position: relative;
  * {
    width: 100%;
  }
  li + li {
    margin-top: 15px;
  }
  .tag {
    background: white;
    color: var(--rosa-eco);
    font-size: 1em;
  }
  .tag span {
    overflow: hidden;
    text-overflow: ellipsis;
    transition: 0.3s;
  }
  .tag span:hover {
    overflow: visible;
    text-overflow: initial;
    transition: 0.3s;
    white-space: normal;
  }
}
  .field-label {
    color: red;
    flex-basis: 151px;
    text-align: left;
  }
  .field-body {
    width: 50%;
    border: solid 1px #dedede;
    border-radius: 5px;
    box-shadow: 0 5px 10px -5px;
    display: flex;
    transition: 0.3;
    overflow: hidden;
    background: white;
  }
  .field-body:hover {
    flex-wrap: wrap;
    transition: 0.5s;
  }
  

</style>
